var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingDonnees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    viewBox: "0 0 113.25 51",
    height: 68,
    preserveAspectRatio: "xMidYMid",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.29 15.66h20.964v1.031H35.289Zm19.937 1.031h1.027v21.313h-1.027zm-19.938 0h1.031v21.313h-1.03zm0 21.313h20.965v1.031H35.289Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.29 42.066h20.964v1.032H35.289Zm19.937 1.032h1.027v7.734h-1.027zm-19.938 0h1.031v7.734h-1.03zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.45 27h19.652v23.832H10.449Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.668 46.645v6.601h-.516v-.512h18.364v.512h-.52V36.762h.512l-.36.367-9.171-8.906.359-.368.363.364-8.66 8.633c-.2.199-.527.199-.726 0l-.2-.528 9.211-9.195 9.707 9.414v17.219H10.637v-7.117c0-.286.23-.516.515-.516l.516.234zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.094 38.004h29.363v1.031H31.094Zm28.328 1.031h1.035v3.031h-1.035zm-28.328 0h1.031v3.031h-1.031zm0 3.031h29.363v1.032H31.094Zm.515 1.032h28.848v.004H31.609Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.441 45.113h13.625v1.032H38.441zm12.586 1.032h1.04v4.687h-1.04zm-12.586 0h1.032v4.687H38.44zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.094 11.09H59.93v1.031H31.094Zm27.8 1.031h1.036v3.031h-1.035zm-27.8 0h1.031v3.031h-1.031zm0 3.031H59.93v1.032H31.094Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.441 6.52H52.59v1.03H38.44Zm13.114 1.03h1.035v3.54h-1.035zm-13.114 0h1.032v3.54H38.44zm0 3.54H52.59v1.031H38.44Zm.516 1.031H52.59v.004H38.957Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.629 45.086h1.281v5.746H44.63zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.734 53.246V45.63c0-.285.23-.516.512-.516l.516.235v7.898c0 .29-.23.516-.516.516l-.512-.23Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.055 18.598h1.28v5.765h-1.28zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.29 19.223v4.57c0 .289-.235.516-.517.516l-.515-.235v-4.851c0-.285.234-.516.515-.516l.516.234zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 18.598h1.21v5.765H40Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.047 19.223v4.57c0 .289-.234.516-.516.516l-.515-.235v-4.851c0-.285.234-.516.515-.516l.516.234zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 18.598h1.105v5.765H51Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.059 19.223v4.57c0 .289-.23.516-.516.516l-.516-.235v-4.851c0-.285.235-.516.516-.516l.516.234zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 28.852h1.105v5.765H51Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.059 29.379v4.57c0 .29-.23.516-.516.516l-.516-.23v-4.856c0-.285.235-.516.516-.516l.516.235zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.055 28.852h1.28v5.765h-1.28zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.29 29.379v4.57c0 .29-.235.516-.517.516l-.515-.23v-4.856c0-.285.234-.516.515-.516l.516.235zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 28.852h1.21v5.765H40Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.047 29.379v4.57c0 .29-.234.516-.516.516l-.515-.23v-4.856c0-.285.234-.516.515-.516l.516.235zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 44.02h4.84v6.812H18Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.496 46.668h.484v6.578h-.484v-.48h3.672v.48h-.48v-6.152l.015-.059.004-.043-.02-.265.481-.082h-.48c0-.903-.653-1.551-1.352-1.551-.7 0-1.352.648-1.352 1.55h-.48.48l-.004.16-.007.055-.008.098v.035l.004.04-.465.12v-.484m0 .969h-.375l-.094-.364L18 47.07v-.086l.008-.148.012-.156v-.04c0-1.343.996-2.515 2.32-2.515 1.324 0 2.32 1.172 2.32 2.516l.004.078.004.062.031.293-.52.078h.481v6.578h-4.648v-6.574h.48v.48zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 34.406h2.266v5.766H21Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.219 37.254c0-1.543-.473-2.793-1.051-2.793s-1.05 1.25-1.05 2.793c0 1.539.472 2.789 1.05 2.789.578 0 1.05-1.25 1.05-2.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.855 34.406h2.352v5.766h-2.352zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.023 37.254c0-1.543-.472-2.793-1.05-2.793-.578 0-1.051 1.25-1.051 2.793 0 1.539.473 2.789 1.05 2.789.579 0 1.051-1.25 1.051-2.79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05 31h13.458v17.504H1.05Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.418 31.613 4.562 6.184-.414.305.414-.305c.907 1.23 1.415 2.73 1.313 4.273l-.008.04-.515-.036.515.04c-.039.511-.16 1.91-1.14 3.308-.235.328-1.735 2.394-4.555 2.75l-.067-.512.067.512c-2.285.285-4.86-.633-6.27-2.766a5.88 5.88 0 0 1-.812-1.89l.504-.118-.504.118c-.387-1.684.05-3.426 1.039-4.817l.422.297-.422-.297 3.172-4.472 2.273-3.192.422.57m-.832.614.414-.305.422.297c-.617.871-1.238 1.738-1.855 2.613l-3.176 4.477c-.836 1.176-1.184 2.617-.871 3.98.117.504.32 1.032.668 1.551l-.434.281.434-.281c1.16 1.762 3.32 2.559 5.273 2.309 2.363-.297 3.64-2.047 3.84-2.325l.426.297-.426-.297c.816-1.16.926-2.328.96-2.789v-.039l.513.035-.512-.035c.086-1.265-.332-2.535-1.113-3.59l-4.56-6.171Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.457 39.32h1.07v11.512h-1.07Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52 40.043v12.695a.518.518 0 0 1-.516.516l-.516-.234V40.043c0-.285.235-.516.516-.516l.516.235zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 13.043h19.226v37.789H70.266Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.422 46.742v5.84h-.488v-.488h17.988v.488h-.484V13.668h.484v.484H70.934a.487.487 0 0 1-.485-.484l.219-.488H89.41v39.886H70.45v-6.324c0-.265.218-.484.484-.484l.488.219zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.387 35.047h11.96v11.75h-11.96zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.262 40.91a5.833 5.833 0 1 1-11.668 0h.484-.484c0-3.226 2.61-5.84 5.832-5.84v.485-.485a5.837 5.837 0 0 1 5.836 5.84h-.489.489m-.973 0a4.861 4.861 0 1 0-9.723 0 4.86 4.86 0 1 0 9.723 0zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.941 45.727H107v5.105h-1.059zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.941 52.094v-5.836c0-.27.22-.488.485-.488l.488.218v6.106c0 .27-.219.488-.488.488l-.485-.219zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.828 40.813H92.91v1.07H72.828Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.852 41.879h-.973v-.969h19.45c.265 0 .484.219.484.485l-.22.484H72.88v-.969h.973c.265 0 .484.219.484.485l-.219.484zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 35.473h17.3v1.07h-17.3Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.934 35.555H86.98c.266 0 .485.218.485.488l-.219.484H70.934a.487.487 0 0 1-.485-.484l.219-.488zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 30.133h19.226v1.066H70.266Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.934 30.207h17.988c.27 0 .488.219.488.484l-.219.489H70.934a.488.488 0 0 1-.485-.489l.219-.484zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 24.793H92.91v1.066H70.266Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.934 24.855h21.394c.266 0 .484.22.484.485l-.218.488h-21.66a.488.488 0 0 1-.485-.488l.219-.485zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 19h19.652v1H70.266Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.934 19.016H89.41c.266 0 .485.218.485.484l-.22.488H70.935a.488.488 0 0 1-.485-.488l.219-.484zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.762 19.45h5.984v1.07h-5.984zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.133 20.477h-4.86a.488.488 0 0 1-.488-.485l.219-.488h5.129c.27 0 .488.219.488.488l-.219.485zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.121 30.559h6.625v1.28h-6.625zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.133 31.664h-5.348a.487.487 0 0 1-.484-.484l.219-.489h5.613c.27 0 .488.22.488.489l-.219.484zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 39.746h1.129v11.086H67Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.043 52.582v-12.16c0-.266.219-.484.488-.484l.485.218v12.426a.487.487 0 0 1-.485.484l-.488-.218zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.504 32.055h12.18V48h-12.18Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.93 32.914-.07.098-3.907 5.648-.406.586c-.305.438-.879 1.387-.883 2.64h-.488.488c-.004 1.973 1.41 3.704 3.106 4.415l-.188.445.188-.445c2.109.883 4.949.316 6.203-1.75.53-.871.652-1.79.593-2.613l.489-.032-.489.032c-.07-1.055-.484-2.07-1.12-2.95l.394-.289-.395.29c-.597-.821-1.246-1.747-1.89-2.669l-1.88-2.656c-.183-.258-.362-.5-.538-.734l-.117-.52c.43-.32.734-.277.894-.062l.36.484.19.258c.595.82 1.243 1.746 1.888 2.668l1.878 2.656c.73 1 1.223 2.188 1.305 3.457.067.961-.074 2.094-.734 3.18l-.414-.254.418.254c-1.555 2.566-4.965 3.168-7.41 2.144-1.98-.832-3.704-2.879-3.7-5.316.004-1.543.707-2.691 1.063-3.2l.398.286-.398-.278.398-.578c1.024-1.484 3.617-5.226 3.907-5.652l.398.277-.398-.277.07-.098.457-.277.496.61zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.266 13.043h1.28v24.566h-1.28zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.422 13.668v23.348a.488.488 0 0 1-.488.484l-.485-.219V13.668c0-.27.219-.488.485-.488l.488.218zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 3.855h15.746v46.977H84Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.621 11.723v41.343H84.063V11.723h.484-.484c0-4.301 3.484-7.785 7.777-7.785v.484-.484a7.785 7.785 0 0 1 7.781 7.785h-.488.488m-.973 0A6.815 6.815 0 0 0 91.84 4.91a6.807 6.807 0 0 0-6.805 6.813v40.859h-.488v-.488h14.586v.488h-.485zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)",
    transform: "translate(.432 -1.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 1.508h118.987v54.687H-1.3Zm0 0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingDonnees);
export default __webpack_public_path__ + "static/media/landing_donnees.82686bc61110a28f52bace87eb779d38.svg";
export { ForwardRef as ReactComponent };